import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ElementType } from '@app/platform/busines-data/Framework/Region';

@Injectable({
  providedIn: 'root'
})
export class StructureTypesEventsService {
  private structureTypesChangeSubject = new BehaviorSubject<ElementType[]>([]);
  private visibleStructureTypesChangeSubject = new BehaviorSubject<ElementType[]>([]);
  public structureTypesChange$: Observable<ElementType[]> = this.structureTypesChangeSubject.asObservable();
  public visibleStructureTypesChange$: Observable<ElementType[]> = this.visibleStructureTypesChangeSubject.asObservable();

  emitStructureTypesChange(selectedTypes: ElementType[]): void {
    this.structureTypesChangeSubject.next(selectedTypes);
  }

  emitVisibleStructureTypesChange(selectedTypes: ElementType[]): void {
    this.visibleStructureTypesChangeSubject.next(selectedTypes);
  }

  getCurrentStructureTypes(): ElementType[] {
    return this.structureTypesChangeSubject.value;
  }

  getCurrentVisibleStructureTypes(): ElementType[] {
    return this.visibleStructureTypesChangeSubject.value;
  }
} 